<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-alert type="error" v-if="informText != ''">{{ informText }}</v-alert>
      </v-col>

      <v-col cols="5">
        Order Summary
        <table width="100%" style="text-align: left; font-size: 14px">
          <tr>
            <td>Order ID:</td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.order_id"
                hide-details
                @keyup="validation"
                @mouseup="validation"
              ></v-text-field>
            </td>
            <td>
              <v-select
                style="margin-left: 5px; margin-bottom: 3px"
                hide-details
                :items="listSites"
                :item-text="(obj) => obj.account"
                :item-value="(obj) => obj.account"
                dense
                outlined
                v-model="dataOrder.amz_account"
                @change="validation"
              ></v-select>
            </td>
          </tr>
          <tr>
            <td>Ship By:</td>
            <template v-if="earliest_ship_date == '' && latest_ship_date == ''">
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="shipBy"
                  style="margin-bottom: 3px"
                  hide-details
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="shipBy"
                  style="margin-left: 5px; margin-bottom: 3px"
                  hide-details
                  @keyup="validation"
                  @mouseup="validation"
                ></v-text-field>
              </td>
            </template>
            <template v-else>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="earliest_ship_date"
                  style="margin-bottom: 3px"
                  hide-details
                  @keyup="validation"
                  @mouseup="validation"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="latest_ship_date"
                  style="margin-left: 5px; margin-bottom: 3px"
                  hide-details
                  @keyup="validation"
                  @mouseup="validation"
                ></v-text-field>
              </td>
            </template>
          </tr>
          <tr>
            <td>Deliver By:</td>
            <template
              v-if="earliest_delivery_date == '' && latest_delivery_date == ''"
            >
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="deliverBy"
                  style="margin-bottom: 3px"
                  hide-details
                  @keyup="validation"
                  @mouseup="validation"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="deliverBy"
                  style="margin-left: 5px; margin-bottom: 3px"
                  hide-details
                  @keyup="validation"
                  @mouseup="validation"
                ></v-text-field>
              </td>
            </template>
            <template v-else>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="earliest_delivery_date"
                  style="margin-bottom: 3px"
                  hide-details
                  @keyup="validation"
                  @mouseup="validation"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  v-model="latest_delivery_date"
                  style="margin-left: 5px; margin-bottom: 3px"
                  hide-details
                  @keyup="validation"
                  @mouseup="validation"
                ></v-text-field>
              </td>
            </template>
          </tr>
          <tr>
            <td>Purchase Date:</td>
            <td colspan="2">
              <v-text-field
                dense
                outlined
                v-model="dataOrder.purchase_date"
                style="margin-bottom: 3px"
                hide-details
                @keyup="validation"
                @mouseup="validation"
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <td>Fulfillment:</td>
            <td colspan="2">
              <v-select
                dense
                outlined
                :items="listFulfillments"
                style="margin-bottom: 3px"
                hide-details
                v-model="dataOrder.fulfillment"
              ></v-select>
            </td>
          </tr>
          <tr>
            <td>Shipping Service:</td>
            <td colspan="2">
              <v-text-field
                dense
                outlined
                style="margin-bottom: 3px"
                hide-details
                v-model="dataOrder.shipping_service"
              ></v-text-field>
            </td>
          </tr>
        </table>
      </v-col>
      <v-col cols="5">
        Ship To
        <table width="100%" style="text-align: left; font-size: 14px">
          <tr>
            <td>Name:</td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_name"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
            <td><span style="margin-left: 5px">ZIP code:</span></td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_zip"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <td>Address 1:</td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_address1"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
            <td><span style="margin-left: 5px">Country:</span></td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_country"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <td>Address 2:</td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_address2"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
            <td><span style="margin-left: 5px">Phone:</span></td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_phone"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <td>City:</td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_city"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <td>Province:</td>
            <td>
              <v-text-field
                dense
                outlined
                v-model="dataOrder.shipping_province"
                style="margin-bottom: 3px"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </table>
      </v-col>
      <v-col cols="2">
        Payment
        <table width="100%" style="text-align: left; font-size: 14px">
          <tr>
            <td>Item Total:</td>
            <td>{{ dataOrder.item_total }}</td>
          </tr>
          <tr>
            <td>Shipping total:</td>
            <td>{{ dataOrder.shipping_total }}</td>
          </tr>
          <tr>
            <td>Tax total:</td>
            <td>{{ dataOrder.tax_total }}</td>
          </tr>
          <tr>
            <td>Grand total:</td>
            <td>{{ parseFloat(dataOrder.grand_total).toFixed(2) }}</td>
          </tr>
        </table>
      </v-col>

      <v-col cols="12">
        <v-btn color="success" @click="addItem">ADD ITEM</v-btn>
      </v-col>

      <v-col cols="10">
        Items
        <div v-for="(i, index) in itemsInOrder" :key="index">
          <div class="border pa-1">
            <table width="100%" style="text-align: left; font-size: 14px">
              <tr>
                <td>Title</td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.title"
                    style="margin-bottom: 3px"
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">Order Item ID</span></td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.item_id"
                    style="margin-bottom: 3px"
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">Item Subtotal: </span></td>
                <td>{{ i.item_subtotal }}</td>
              </tr>
              <tr>
                <td>Product Link</td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.product_link"
                    style="margin-bottom: 3px"
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">Quantity</span></td>
                <td>
                  <v-text-field
                    type="number"
                    dense
                    outlined
                    v-model="i.item_quantity"
                    style="margin-bottom: 3px"
                    @mouseup="
                      toItemSubtotal(i.item_quantity, i.unit_price, index)
                    "
                    @keyup="
                      toItemSubtotal(i.item_quantity, i.unit_price, index)
                    "
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">Shipping Total</span></td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.shipping"
                    style="margin-bottom: 3px"
                    hide-details
                    type="number"
                    @mouseup="
                      toItemTotal(i.item_subtotal, i.shipping, i.tax, index)
                    "
                    @keyup="
                      toItemTotal(i.item_subtotal, i.shipping, i.tax, index)
                    "
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>ASIN</td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.asin"
                    style="margin-bottom: 3px"
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">Unit Price</span></td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.unit_price"
                    style="margin-bottom: 3px"
                    type="number"
                    @mouseup="
                      toItemSubtotal(i.item_quantity, i.unit_price, index)
                    "
                    @keyup="
                      toItemSubtotal(i.item_quantity, i.unit_price, index)
                    "
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">Tax</span></td>
                <td>
                  <v-text-field
                    type="number"
                    dense
                    outlined
                    v-model="i.tax"
                    style="margin-bottom: 3px"
                    hide-details
                    @mouseup="
                      toItemTotal(i.item_subtotal, i.shipping, i.tax, index)
                    "
                    @keyup="
                      toItemTotal(i.item_subtotal, i.shipping, i.tax, index)
                    "
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>SKU</td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.amz_sku"
                    style="margin-bottom: 3px"
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">GBA Product Type</span></td>
                <td>
                  <v-select
                    dense
                    outlined
                    :items="listProductTypes"
                    :item-text="(obj) => obj.product_type"
                    :item-value="(obj) => obj"
                    v-model="i.productType_selected"
                    style="margin-bottom: 3px"
                    hide-details
                    @change="addProductTypeToItem(index)"
                  ></v-select>
                </td>
                <td><span style="margin-left: 5px">Item Total: </span></td>
                <td>{{ parseFloat(i.item_total).toFixed(2) }}</td>
              </tr>
              <tr>
                <td>GBA product code</td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    v-model="i.gba_product_code"
                    style="margin-bottom: 3px"
                    hide-details
                  ></v-text-field>
                </td>
                <td><span style="margin-left: 5px">GBA Variant</span></td>
                <td>
                  <v-select
                    :items="i.productType_selected.variants"
                    :item-text="(obj) => obj.sku"
                    :item-value="(obj) => obj.sku"
                    dense
                    outlined
                    v-model="i.gba_sku"
                    style="margin-bottom: 3px"
                    hide-details
                  ></v-select>
                </td>
                <td>
                  <v-btn
                    color="red"
                    dark
                    small
                    @click="deleteItem(index)"
                    style="margin-left: 25px"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </td>
              </tr>
            </table>
            <v-btn
              color="info"
              @click="addCustom(index)"
              style="margin-bottom: 5px"
              >ADD CUSTOMIZATION</v-btn
            >
            <div v-for="(j, indexj) in i.customizations" :key="indexj">
              <table width="50%" style="text-align: left">
                <tr>
                  <td>Option</td>
                  <td>
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      v-model="j.name"
                    ></v-text-field>
                  </td>
                  <td><span style="margin-left: 5px">Value</span></td>
                  <td>
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      v-model="j.value"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-btn
                      small
                      dark
                      color="orange"
                      hide-details
                      style="margin-left: 5px"
                      @click="deleteCustom(indexj, index)"
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="2">
        Fulfillment Note
        <v-textarea
          dense
          outlined
          v-model="dataOrder.fulfillment_note"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn @click="saveData" color="success" v-if="showBtn">Create</v-btn>
        <v-btn color="success" v-else disabled>Create</v-btn> &nbsp; &nbsp;
        <v-btn @click="cancelData" color="orange" dark>Cancel</v-btn>
        <!-- <v-btn @click="check">Check</v-btn> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
//import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "CreateAmazonOrder",

  props: {},

  data: () => ({
    listProductTypes: [],
    listSites: [],
    shipBy: "",
    earliest_ship_date: "",
    latest_ship_date: "",
    deliverBy: "",
    earliest_delivery_date: "",
    latest_delivery_date: "",
    listFulfillments: ["Seller", "Amazon"],

    dataOrder: {
      amz_account: "",
      order_id: "",
      earliest_ship_date: "",
      latest_ship_date: "",
      earliest_delivery_date: "",
      latest_delivery_date: "",
      purchase_date: "",
      fulfillment: "",
      shipping_service: "",
      shipping_name: "",
      shipping_address1: "",
      shipping_address2: "",
      shipping_city: "",
      shipping_province: "",
      shipping_zip: "",
      shipping_country: "",
      shipping_phone: "",
      items: [],
      fulfillment_note: "",
      item_total: 0,
      shipping_total: 0,
      tax_total: 0,
      grand_total: 0,
    },

    itemsInOrder: [],
    informText: "",
    showBtn: false,

    itemTemplate: {
      title: "",
      product_link: "",
      asin: "",
      amz_sku: "",
      gba_product_code: "",
      gba_sku: "",
      gba_product_type: "",
      item_id: "",
      item_quantity: 0,
      unit_price: 0,
      shipping: 0,
      tax: 0,
      customizations: [],
      //listVariants: [],
      productType_selected: [],
      variant_id: "",
      item_subtotal: 0,
      item_total: 0,
    },
  }),

  watch: {
    shipBy() {
      if (this.shipBy != "") {
        var temp = this.shipBy.split(" to ");
        this.earliest_ship_date = temp[0];
        this.latest_ship_date = temp[1];
        this.shipBy = "";
      }
    },
    deliverBy() {
      if (this.deliverBy != "") {
        var temp = this.deliverBy.split(" to ");
        this.earliest_delivery_date = temp[0];
        this.latest_delivery_date = temp[1];
        this.deliverBy = "";
      }
    },
    earliest_ship_date() {
      this.dataOrder.earliest_ship_date = this.earliest_ship_date;
    },
    latest_ship_date() {
      this.dataOrder.latest_ship_date = this.latest_ship_date;
    },
    earliest_delivery_date() {
      this.dataOrder.earliest_delivery_date = this.earliest_delivery_date;
    },
    latest_delivery_date() {
      this.dataOrder.latest_delivery_date = this.latest_delivery_date;
    },
  },

  methods: {
    check() {
      console.log("dataOrder: ", this.dataOrder);
      console.log("itemsInOrder: ", this.itemsInOrder);
    },

    cancelData() {
      this.$root.$refs.order.turnOffDialog();
    },

    addItem() {
      this.itemsInOrder.push(JSON.parse(JSON.stringify(this.itemTemplate)));
    },

    deleteItem(index) {
      this.itemsInOrder.splice(index, 1);
    },

    addCustom(index) {
      console.log("index: ", index);
      this.itemsInOrder[index].customizations.push({
        name: "",
        value: "",
      });
    },

    deleteCustom(indexCustom, indexItem) {
      console.log("index: ", indexCustom);
      console.log("data: ", this.itemsInOrder[indexItem]);
      this.itemsInOrder[indexItem].customizations.splice(indexCustom, 1);
    },

    toItemSubtotal(quantity, unitPrice, indexItem) {
      console.log(quantity + " - " + unitPrice + " - " + indexItem);
      this.itemsInOrder[indexItem].item_subtotal =
        parseFloat(quantity) * parseFloat(unitPrice);
    },

    toItemTotal(item_subtotal, shipping, tax, indexItem) {
      console.log(item_subtotal + " - " + shipping + " - " + tax);
      this.itemsInOrder[indexItem].item_total =
        parseFloat(item_subtotal) + parseFloat(shipping) + parseFloat(tax);
      this.toItemTotalPayment();
      this.toShippingTotalPayment();
      this.toTaxTotalPayment();
      this.toGrandTotal();
    },

    toItemTotalPayment() {
      this.dataOrder.item_total = 0;
      for (const i of this.itemsInOrder) {
        this.dataOrder.item_total += parseFloat(i.item_subtotal);
      }
    },
    toShippingTotalPayment() {
      this.dataOrder.shipping_total = 0;
      for (const i of this.itemsInOrder) {
        this.dataOrder.shipping_total += parseFloat(i.shipping);
      }
    },
    toTaxTotalPayment() {
      this.dataOrder.tax_total = 0;
      for (const i of this.itemsInOrder) {
        this.dataOrder.tax_total += parseFloat(i.tax);
      }
    },
    toGrandTotal() {
      this.dataOrder.grand_total = 0;
      this.dataOrder.grand_total =
        parseFloat(this.dataOrder.item_total) +
        parseFloat(this.dataOrder.shipping_total) +
        parseFloat(this.dataOrder.tax_total);
    },

    addProductTypeToItem(index) {
      this.itemsInOrder[index].gba_product_type =
        this.itemsInOrder[index].productType_selected.product_type;
    },

    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "order-create-loadData"
      );

      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "orders/get-data", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);
            this.listProductTypes = response.data.data.productTypes;
            this.listSites = response.data.data.sites;
          })
          .catch((err) => {
            console.log("Err: ", err);
          });
      }
    },

    async saveData() {
      this.informText = "";
      this.showBtn = false;
      // for (const i of this.itemsInOrder) {
      //   i.gba_sku = i.gba_sku.substring(0, 10);
      //   //console.log()
      // }

      this.dataOrder.items = JSON.parse(JSON.stringify(this.itemsInOrder));
      // this.dataOrder.purchase_date = moment(this.dataOrder.purchase_date)
      //   .tz("America/Los_Angeles")
      //   .format();
      // this.dataOrder.earliest_delivery_date = moment(
      //   this.dataOrder.earliest_delivery_date
      // )
      //   .tz("America/Los_Angeles")
      //   .format();
      // this.dataOrder.latest_delivery_date = moment(
      //   this.dataOrder.latest_delivery_date
      // )
      //   .tz("America/Los_Angeles")
      //   .format();
      // this.dataOrder.earliest_ship_date = moment(
      //   this.dataOrder.earliest_ship_date
      // )
      //   .tz("America/Los_Angeles")
      //   .format();
      // this.dataOrder.latest_ship_date = moment(this.dataOrder.latest_ship_date)
      //   .tz("America/Los_Angeles")
      //   .format();

      console.log("this.dataOrder: ", JSON.stringify(this.dataOrder));

      var currentSession = await this.$root.$refs.App.currentSession(
        "order-create-loadData"
      );

      if (currentSession.accessToken) {
        await fetch(window.domain + "orders/amazon", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(this.dataOrder),
        })
          .then(
            (response) =>
              //console.log("response: ", response);
              response.json()

            //this.listProductTypes = response.data.data.productTypes;
            //this.listSites = response.data.data.sites;
          )
          .then((data) => {
            console.log("response: ", data);
            if (data.error_message == "") {
              this.cancelData();
            } else {
              this.showBtn = true;
              this.informText = data.error_message;
            }
          })
          .catch((err) => {
            console.log("Err: ", err);
          });
      }
    },

    validation() {
      if (
        this.dataOrder.order_id != "" &&
        this.dataOrder.amz_account != "" &&
        this.dataOrder.earliest_ship_date != "" &&
        this.dataOrder.latest_ship_date != "" &&
        this.dataOrder.earliest_delivery_date != "" &&
        this.dataOrder.latest_delivery_date != "" &&
        this.dataOrder.purchase_date != ""
      ) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("order");
    if (this.roles.list_orders) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    var currentSession;
    try {
      currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
      console.log("order-mounted currentSession: ", currentSession);
    } catch (error) {
      console.log("order-mounted error: ", error);
    }

    if (currentSession != undefined) {
      this.userId = currentSession.accessToken.payload.username;
      await this.loadData();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>